module.exports = new __parcel__URL__("powerBI.6fbcc628.png").toString();